module.exports = __webpack_public_path__ + "assets/img/check-dark.9f041273.svg";